import React from 'react';
import FadeIn from './FadeIn';
import Button from './Button';
import SafeIcon from '../common/SafeIcon';
import { FiLock, FiCheck } from 'react-icons/fi';

export default function Pricing() {
  const handlePurchase = () => {
    window.location.href = 'https://coassemble.com/learn/IXKIQH';
  };

  return (
    <section id="pricing" className="py-20 px-4 sm:px-6 font-sans">
      <div className="max-w-lg mx-auto">
        <FadeIn>
          <div className="bg-white rounded-3xl shadow-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-900 text-white p-8 text-center">
              <h2 className="text-2xl font-semibold mb-2">Instant Access</h2>
              <div className="flex items-center justify-center mb-4">
                <span className="text-5xl font-extrabold tracking-tight">$1.98</span>
                <span className="text-slate-400 ml-2 uppercase">usd</span>
              </div>
              <p className="text-slate-300 text-sm">One-time payment. Lifetime access.</p>
            </div>

            <div className="p-8">
              <div className="bg-blue-50 text-blue-800 text-sm p-4 rounded-lg mb-8 text-center font-medium">
                The average bank overdraft fee is $35. For less than the cost of a coffee, you can build a system to never pay one again.
              </div>

              <ul className="space-y-4 mb-8">
                {[
                  "Full 7-Day Video Course",
                  "Instant digital access",
                  "Mobile-friendly viewing",
                  "Simple templates included",
                  "No recurring subscriptions"
                ].map((item, i) => (
                  <li key={i} className="flex items-center text-slate-700">
                    <SafeIcon icon={FiCheck} className="text-emerald-500 mr-3 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>

              <Button fullWidth onClick={handlePurchase}>
                Get Instant Access
              </Button>

              <div className="mt-6 flex items-center justify-center text-slate-500 text-sm">
                <SafeIcon icon={FiLock} className="mr-2" />
                Secure, encrypted checkout
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}